import { Building2, FileText, Briefcase, CreditCard } from "lucide-react";

const STEPS = [
  {
    num: 1,
    icon: Building2,
    title: "Secure a Local Sponsor or Agent (If Needed)",
    desc: "While most sectors now allow 100% foreign ownership, some strategic activities still require an Emirati shareholder or Local Service Agent (LSA).",
  },
  {
    num: 2,
    icon: FileText,
    title: "Apply for Your Trade License",
    desc: "Submit your application and required documents, like passport copies and a Memorandum of Association (MOA), to the DED.",
  },
  {
    num: 3,
    icon: Briefcase,
    title: "Set Up Your Office Space",
    desc: "Every mainland company needs a physical address, which can range from a flexi-desk to a fully serviced office.",
  },
  {
    num: 4,
    icon: CreditCard,
    title: "Obtain Visas and a Corporate Bank Account",
    desc: "Apply for visas for yourself and employees. Open a corporate bank account to manage finances.",
  },
];

export default function MainlandSteps() {
  return (
    <section className="py-14 sm:py-16 lg:py-20 xl:py-14 2xl:py-28 px-4 sm:px-6 lg:px-14 bg-[#FAFAFA]">

      {/* 🔥 SUPER CONTAINER (BIG SCREEN FIX) */}
      <div className="w-full mx-auto 
        max-w-[1300px] 
        lg:max-w-[1500px] 
        xl:max-w-[1700px] 
        2xl:max-w-[2000px] 
        3xl:max-w-[2200px]">

        {/* HEADER */}
        <div className="text-center mb-14 sm:mb-16 lg:mb-20 xl:mb-24 max-w-5xl mx-auto">
          <h2 
            className="font-bold text-[#000000] leading-tight mb-4 sm:mb-5"
            style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: "700", lineHeight: "1.3" }}
          >
            How to Set Up a Mainland Company in Dubai
          </h2>
        </div>

        {/* CARDS */}
        <div className="grid 
          grid-cols-1 
          sm:grid-cols-2 
          lg:grid-cols-4 
          xl:grid-cols-4 
          2xl:grid-cols-4 
          3xl:grid-cols-4 
          gap-5 sm:gap-6 lg:gap-7 xl:gap-5">
          {STEPS.map((step, i) => {
            const Icon = step.icon;

            return (
              <div
                key={step.num}
                className="bg-[#fafafa] shadow-xl rounded-xl sm:rounded-[16px] p-5 sm:p-6 lg:p-7 relative"
              >
                {/* ICON */}
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#B8893A]/10 mb-4">
                  <Icon size={18} className=" text-[#B8893A]" />
                </div>

                {/* TITLE */}
                <h3 
                  className="font-semibold text-black mb-2"
                  style={{ fontSize: "clamp(16px, 1.8vw, 18px)", fontWeight: "600" }}
                >
                  {step.title}
                </h3>

                {/* DESC */}
                <p 
                  className="text-black"
                  style={{ fontSize: "clamp(13px, 1.1vw, 15px)", lineHeight: "1.6" }}
                >
                  {step.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
